export const appVersion = { version: '3917367' };
